import './src/styles/main.scss';

// import 'jquery/dist/jquery.min.js';
// import 'bootstrap-sass/assets/javascripts/bootstrap.min.js';
if (typeof window !== 'undefined') {
	window.jQuery = window.$ = require('jquery');
	require('bootstrap-sass/assets/javascripts/bootstrap.min.js');
}
